<div class="container font-white">
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <div class="fw-semibold fs-32">{{ centerData.CenterID ? "Update" : "Add" }} Center</div>
      <div class="fs-14 fw-normal mb-3">Fill up all your details and apply for job at MMRCL.</div>
    </div>
    <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" class="cursor-pointer" (click)="onClose()" (keydown)="onClose()" tabindex="0"></div>
  </div>
</div>

<hr class="font-white svg-line" />

<div class="container font-white d-flex">
  <!-- <div class="p-4">
    <aside class="stepper text-white position-relative d-flex align-items-start flex-column">
      <div class="step d-flex align-items-center gap-2" [class.active]="step >= 1" [class.completed]="step > 1">
        <div [innerHtml]="SVG_ICONS.Personal_DETAILS_ICON() | sanitizer : 'html'"></div>
        <div class="label" [class.active-label]="step >= 1">Center Details</div>
      </div>
      <div [innerHtml]="SVG_ICONS.LINE(step >= 1) | sanitizer : 'html'" class="ms-3 mt-2"></div>
      <div class="step d-flex align-items-center gap-2" [class.active]="step >= 2" [class.completed]="step > 2">
        <div [innerHtml]="SVG_ICONS.DOCS_UPLOAD_ICON(step >= 2) | sanitizer : 'html'"></div>
        <div class="label" [class.active-label]="step >= 2">Contact Details</div>
      </div>
    </aside>
  </div> -->

  <!-- <div class="d-flex align-items-center svg-line" style="height: 100vh; margin-top: -16px">
      <div class="vr"></div>
    </div> -->

  <div class="flex-grow-1 ms-md-5">
    <form>
      <!-- Step 1 -->
      @if(ErrorMsg.length > 0){
      <div AsteriskMessage [messageList]="ErrorMsg"></div>
      } @if(step === 1){
      <div>
        <div class="d-flex">
          <div class="fs-16 fw-bold mb-3">Center Details</div>
          <div [innerHtml]="SVG_ICONS.HR_LINE() | sanitizer : 'html'" class="ms-4 hide-on-mobile"></div>
        </div>

        <!-- <app-document-upload displayAs="profile" category="Profile" [documents]="uploadedDocuments['Profile'] || []" (documentsChange)="updateDocuments($event)" (documentRemove)="removeFile($event)">
        </app-document-upload> -->
        <div class="row g-3 mt-2">
          <div class="col-12">
            <label for="centerName" class="fs-14 fw-normal font-white">Center Name <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white" maxlength="100" [(ngModel)]="centerData.CenterName" name="centerName" placeholder="Center Name" />
          </div>
          <!-- <div class="col-md-6 col-12">
            <label for="centerCode" class="fs-14 fw-normal font-white">Center Code <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white" [(ngModel)]="centerData.CenterID" name="centerCode" placeholder="Center Code" />
          </div> -->
          <div class="col-md-5 col-12">
            <label for="">Region <span class="text-danger">*</span></label>

            <app-multi-select-dropdown
              label=""
              placeholder="Select a region"
              [items]="regionList"
              valueProperty="RegionID"
              displayProperty="RegionName"
              [(model)]="centerData.RegionID"
              (modelChange)="onRegionChange()">
            </app-multi-select-dropdown>
          </div>
          <div class="col-md-1 col-12 mt-5">
            <div [innerHtml]="SVG_ICONS.ADD_BUTTON() | sanitizer : 'html'" class="mt-2 d-flex justify-content-end cursor-pointer" (click)="onAddRegion()" tabindex="0" (keydown)="onAddRegion()"></div>
          </div>

          <div class="col-md-5 col-12">
            <label for="">Area <span class="text-danger">*</span></label>
            <app-multi-select-dropdown label="" placeholder="Select an area" [items]="areaList" valueProperty="AreaID" displayProperty="AreaName" [(model)]="centerData.AreaID">
            </app-multi-select-dropdown>
          </div>
          <div class="col-md-1 col-12 mt-5">
            <div [innerHtml]="SVG_ICONS.ADD_BUTTON() | sanitizer : 'html'" class="mt-2 d-flex justify-content-end cursor-pointer" (click)="onAddArea()" tabindex="0" (keydown)="onAddArea()"></div>
          </div>
        </div>

        <div class="d-flex mt-4 mb-4">
          <div class="fs-16 fw-bold mb-3">Add Contact Details</div>
          <div [innerHtml]="SVG_ICONS.HR_LINE() | sanitizer : 'html'" class="ms-4 hide-on-mobile"></div>
        </div>
        <div class="row g-3">
          <div class="col-md-6 col-12">
            <label for="contactNumber" class="fs-14 fw-normal font-white">Contact Number <span class="text-danger">*</span></label>
            <div class="d-flex align-items-center gap-2">
              <span class="input-group-text bg-form-control font-white text-white border-0">+91</span>
              <input
                class="form-control bg-form-control font-white text-white border-0"
                name="contactNumber"
                [(ngModel)]="centerData.ContactNumber"
                onlyNumber
                maxlength="10"
                placeholder="Contact Number" />
            </div>
          </div>
          <div class="col-md-6 col-12">
            <label for="alternateContactNumber" class="fs-14 fw-normal font-white">Alternate Contact Number </label>
            <div class="d-flex align-items-center gap-2">
              <span class="input-group-text bg-form-control font-white text-white border-0">+91</span>
              <input
                class="form-control bg-form-control font-white text-white border-0"
                name="alternateContactNumber"
                [(ngModel)]="centerData.AlternateNumber"
                onlyNumber
                maxlength="10"
                placeholder="Alternate Contact Number" />
            </div>
          </div>
          <div class="col-md-6 col-12">
            <label for="email" class="fs-14 fw-normal font-white">Email </label>
            <input class="form-control bg-form-control border-0 font-white" name="email" [(ngModel)]="centerData.Email" placeholder="Email" />
          </div>
          <div class="col-12">
            <label for="address" class="fs-14 fw-normal font-white">Address <span class="text-danger">*</span></label>
            <textarea class="form-control bg-form-control border-0 font-white" maxlength="255" [(ngModel)]="centerData.Address" name="address" placeholder="Address"></textarea>
          </div>
          <div class="col-md-4 col-12">
            <label for="Pincode" class="fs-14 fw-normal font-white">PIN Code <span class="text-danger">*</span></label>
            <input
              class="form-control bg-form-control border-0 font-white"
              [(ngModel)]="centerData.Pincode"
              name="Pincode"
              placeholder="PIN Code"
              onlyNumber
              maxlength="6"
              (blur)="getAddressByPincode(centerData.Pincode)" />
          </div>
          <div class="col-md-4 col-12">
            <label for="city" class="fs-14 fw-normal font-white">City <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white" name="city" maxlength="45" onlyCharacter [(ngModel)]="centerData.District" placeholder="City" />
          </div>
          <div class="col-md-4 col-12">
            <label for="state" class="fs-14 fw-normal font-white">State <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white" name="state" maxlength="45" onlyCharacter [(ngModel)]="centerData.State" placeholder="State" />
          </div>
          <div class="col-md-4 col-12">
            <label for="pinCode" class="fs-14 fw-normal font-white">Country <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white" name="pinCode" onlyCharacter [(ngModel)]="centerData.Country" placeholder="Country" />
          </div>
        </div>
      </div>
      }

      <!-- Step 2 -->
      @if(step === 2){
      <div>
        <!-- <div class="d-flex">
          <div class="fs-16 fw-bold mb-3">Fitness Basics</div>
          <div [innerHtml]="SVG_ICONS.HR_LINE() | sanitizer : 'html'" class="ms-4 svg-line"></div>
        </div>
        <div class="row g-3">
          <div class="col-md-4">
            <label for="MaxCapacity" class="fs-14 fw-normal font-white">Max Capacity</label>
            <input class="form-control bg-form-control border-0 font-white" name="MaxCapacity" [(ngModel)]="center.MaxCapacity" placeholder="Max Capacity" />
          </div>
        </div> -->
        <div class="col-md-6 col-12 position-relative">
          <!-- <label for="TrainerID" class="fs-14 fw-normal font-white">Select Trainer</label> -->

          <!-- Selected Value Box -->
          <!-- <div
            class="custom-dropdown bg-form-control border-0 font-white w-100 pe-5"
            (click)="isRegionDropdownOpen = !isRegionDropdownOpen"
            tabindex="0"
            role="button"
            (keyup)="isRegionDropdownOpen = !isRegionDropdownOpen">
            <div class="fs-14 font-white p-1">
              <div class="fw-bold">{{ selectedTrainer?.TrainerName || "Select Trainer" }} {{ selectedTrainer?.TrainerLastName }}</div>
              <div class="fs-12 font-gray" *ngIf="selectedTrainer">
                {{ selectedTrainer?.MobileNumber }}
              </div>
            </div>
            <div class="custom-select-arrow" [ngClass]="{ 'rotate-arrow': isRegionDropdownOpen }">▼</div>
          </div> -->

          <!-- Dropdown List -->
          <!-- <div class="font-white border-radius-5 mt-2 overflow-hidden" *ngIf="isRegionDropdownOpen">
            <div class="p-2 cursor-pointer dropdown-item" *ngFor="let trainer of trainerList" (click)="selectTrainer(trainer)" tabindex="0" role="button" (keyup)="selectTrainer(trainer)">
              <div class="fw-bold">{{ trainer.TrainerName }} {{ trainer.TrainerLastName }}</div>
              <div class="fs-12 font-gray">{{ trainer.MobileNumber }}</div>
            </div>
          </div> -->
        </div>
      </div>
      }

      <!-- Buttons -->
      <div class="mt-4 d-flex justify-content-end">
        <!-- @if(step > 1){
        <button type="button" class="btn btn-outline-light" (click)="previousStep()">Back</button>
        } @if(step < 2){
        <button type="button" class="btn btn-success" (click)="nextStep()">Next</button>
        } @if(step === 2){
        <button type="submit" class="btn btn-success" (click)="onSubmit()">Submit</button>
        } -->
        <button type="submit" class="add-btn px-4 py-2" (click)="onSubmit()">{{ centerData.CenterID ? "Update" : "Submit" }}</button>
      </div>
    </form>
  </div>
</div>
